import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Optional, ChangeDetectorRef, Injector, TemplateRef, Directive, ComponentFactoryResolver, ApplicationRef, ViewContainerRef, ElementRef, Renderer2, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { timer, from, Subscription } from 'rxjs';
import { style, trigger, transition, animate } from '@angular/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgBusyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.wrapperClass);
    ɵngcc0.ɵɵproperty("@flyInOut", undefined)("@.disabled", ctx_r0.disableAnimation);
} }
function NgBusyComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@flyInOut", undefined)("@.disabled", ctx_r1.disableAnimation);
} }
const _c0 = ["*"];
class InstanceConfigHolderService {
    constructor() { }
}
InstanceConfigHolderService.ɵfac = function InstanceConfigHolderService_Factory(t) { return new (t || InstanceConfigHolderService)(); };
InstanceConfigHolderService.ɵprov = i0.ɵɵdefineInjectable({ factory: function InstanceConfigHolderService_Factory() { return new InstanceConfigHolderService(); }, token: InstanceConfigHolderService, providedIn: "root" });
InstanceConfigHolderService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InstanceConfigHolderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class BusyConfig {
    constructor(config = {}) {
        for (const option of Object.keys(BUSY_CONFIG_DEFAULTS)) {
            this[option] = config[option] !== undefined ? config[option] : BUSY_CONFIG_DEFAULTS[option];
        }
    }
}
class DefaultBusyComponent {
    constructor(instanceConfigHolder) {
        this.instanceConfigHolder = instanceConfigHolder;
    }
    get message() {
        return this.instanceConfigHolder.config.message;
    }
}
DefaultBusyComponent.ɵfac = function DefaultBusyComponent_Factory(t) { return new (t || DefaultBusyComponent)(ɵngcc0.ɵɵdirectiveInject('instanceConfigHolder')); };
DefaultBusyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DefaultBusyComponent, selectors: [["default-busy"]], decls: 17, vars: 1, consts: [[1, "ng-busy-default-wrapper"], [1, "ng-busy-default-sign"], [1, "ng-busy-default-spinner"], [1, "bar1"], [1, "bar2"], [1, "bar3"], [1, "bar4"], [1, "bar5"], [1, "bar6"], [1, "bar7"], [1, "bar8"], [1, "bar9"], [1, "bar10"], [1, "bar11"], [1, "bar12"], [1, "ng-busy-default-text"]], template: function DefaultBusyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelement(5, "div", 5);
        ɵngcc0.ɵɵelement(6, "div", 6);
        ɵngcc0.ɵɵelement(7, "div", 7);
        ɵngcc0.ɵɵelement(8, "div", 8);
        ɵngcc0.ɵɵelement(9, "div", 9);
        ɵngcc0.ɵɵelement(10, "div", 10);
        ɵngcc0.ɵɵelement(11, "div", 11);
        ɵngcc0.ɵɵelement(12, "div", 12);
        ɵngcc0.ɵɵelement(13, "div", 13);
        ɵngcc0.ɵɵelement(14, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 15);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(16);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, encapsulation: 2 });
DefaultBusyComponent.ctorParameters = () => [
    { type: InstanceConfigHolderService, decorators: [{ type: Inject, args: ['instanceConfigHolder',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultBusyComponent, [{
        type: Component,
        args: [{
                selector: 'default-busy',
                template: `
      <div class="ng-busy-default-wrapper">
          <div class="ng-busy-default-sign">
              <div class="ng-busy-default-spinner">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                  <div class="bar4"></div>
                  <div class="bar5"></div>
                  <div class="bar6"></div>
                  <div class="bar7"></div>
                  <div class="bar8"></div>
                  <div class="bar9"></div>
                  <div class="bar10"></div>
                  <div class="bar11"></div>
                  <div class="bar12"></div>
              </div>
              <div class="ng-busy-default-text">{{message}}</div>
          </div>
      </div>
  `
            }]
    }], function () { return [{ type: InstanceConfigHolderService, decorators: [{
                type: Inject,
                args: ['instanceConfigHolder']
            }] }]; }, null); })();
const BUSY_CONFIG_DEFAULTS = {
    template: DefaultBusyComponent,
    templateNgStyle: {},
    delay: 0,
    minDuration: 0,
    backdrop: true,
    message: 'Please wait...',
    wrapperClass: 'ng-busy',
    disableAnimation: false
};

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

class BusyTrackerService {
    constructor() {
        this.isDelayProcessing = false;
        this.isDurationProcessing = false;
        this.isBusiesProcessing = false;
        this.busyQueue = [];
        this.__isActive = false;
        this.onStartBusy = new EventEmitter();
        this.onStopBusy = new EventEmitter();
    }
    get isActive() {
        return this.__isActive;
    }
    set isActive(val) {
        if (this.__isActive === false && val === true && this.onStartBusy) {
            this.onStartBusy.emit();
        }
        if (this.__isActive === true && val === false && this.onStopBusy) {
            this.isBusiesProcessing = false;
            this.onStopBusy.emit();
        }
        this.__isActive = val;
    }
    get busyList() {
        return this.busyQueue;
    }
    load(options) {
        this.loadBusyQueue(options.busyList);
        this.startLoading(options);
    }
    updateActiveStatus() {
        this.isActive = this.isBusiesProcessing &&
            !this.isDelayProcessing &&
            (this.isDurationProcessing || this.busyQueue.length > 0);
    }
    startLoading(options) {
        if (!this.isBusiesProcessing && this.busyList.length > 0) {
            this.isBusiesProcessing = true;
            this.isDelayProcessing = true;
            this.updateActiveStatus();
            timer(options.delay).subscribe(() => {
                this.isDelayProcessing = false;
                this.isDurationProcessing = true;
                this.updateActiveStatus();
                timer(options.minDuration).subscribe(() => {
                    this.isDurationProcessing = false;
                    this.updateActiveStatus();
                });
            });
        }
    }
    loadBusyQueue(busies) {
        busies.filter((busy) => {
            return busy && !busy.hasOwnProperty('__loaded_mark_by_ng_busy');
        }).forEach((busy) => {
            Object.defineProperty(busy, '__loaded_mark_by_ng_busy', {
                value: true, configurable: false, enumerable: false, writable: false
            });
            let cur_busy;
            if (isPromise(busy)) {
                cur_busy = from(busy).subscribe();
            }
            else {
                cur_busy = busy;
            }
            this.appendToQueue(cur_busy);
        });
    }
    appendToQueue(busy) {
        this.busyQueue.push(busy);
        busy.add(() => {
            this.busyQueue = this.busyQueue.filter((cur) => !cur.closed);
            this.updateActiveStatus();
        });
    }
    ngOnDestroy() {
    }
}
BusyTrackerService.ɵfac = function BusyTrackerService_Factory(t) { return new (t || BusyTrackerService)(); };
BusyTrackerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BusyTrackerService_Factory() { return new BusyTrackerService(); }, token: BusyTrackerService, providedIn: "root" });
BusyTrackerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BusyTrackerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class BusyConfigHolderService {
    constructor(config) {
        this.config = Object.assign({}, BUSY_CONFIG_DEFAULTS, config || new BusyConfig());
    }
}
BusyConfigHolderService.ɵfac = function BusyConfigHolderService_Factory(t) { return new (t || BusyConfigHolderService)(ɵngcc0.ɵɵinject(BusyConfig, 8)); };
BusyConfigHolderService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BusyConfigHolderService_Factory() { return new BusyConfigHolderService(i0.ɵɵinject(BusyConfig, 8)); }, token: BusyConfigHolderService, providedIn: "root" });
BusyConfigHolderService.ctorParameters = () => [
    { type: BusyConfig, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BusyConfigHolderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: BusyConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

const inactiveStyle = style({
    opacity: 0,
    transform: 'translateY(-40px)'
});
const timing = '.3s ease';
class NgBusyComponent {
    constructor(instanceConfigHolder, busyEmitter, cdr) {
        this.instanceConfigHolder = instanceConfigHolder;
        this.busyEmitter = busyEmitter;
        this.cdr = cdr;
        this.disableAnimation = false;
        this.showBackdrop = true;
        this.isActive = false;
        this.busyMonitor = this.busyEmitter.subscribe((isActive) => {
            const config = this.instanceConfigHolder.config;
            this.isActive = isActive;
            this.wrapperClass = config.wrapperClass;
            this.showBackdrop = config.backdrop;
            this.disableAnimation = config.disableAnimation;
            if (this.cdr) {
                this.cdr.markForCheck();
            }
        });
    }
    ngOnDestroy() {
        if (this.busyMonitor) {
            this.busyMonitor.unsubscribe();
        }
    }
}
NgBusyComponent.ɵfac = function NgBusyComponent_Factory(t) { return new (t || NgBusyComponent)(ɵngcc0.ɵɵdirectiveInject('instanceConfigHolder'), ɵngcc0.ɵɵdirectiveInject('busyEmitter'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgBusyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgBusyComponent, selectors: [["lib-ng-busy"]], ngContentSelectors: _c0, decls: 2, vars: 2, consts: [[3, "class", 4, "ngIf"], ["class", "ng-busy-backdrop", 4, "ngIf"], [1, "ng-busy-backdrop"]], template: function NgBusyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NgBusyComponent_div_0_Template, 2, 4, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgBusyComponent_div_1_Template, 1, 2, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showBackdrop && ctx.isActive);
    } }, directives: [ɵngcc1.NgIf], styles: [""], data: { animation: [
            trigger('flyInOut', [
                transition('void => *', [
                    inactiveStyle,
                    animate(timing)
                ]),
                transition('* => void', [
                    animate(timing, inactiveStyle)
                ])
            ])
        ] } });
NgBusyComponent.ctorParameters = () => [
    { type: InstanceConfigHolderService, decorators: [{ type: Inject, args: ['instanceConfigHolder',] }] },
    { type: EventEmitter, decorators: [{ type: Inject, args: ['busyEmitter',] }] },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgBusyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ng-busy',
                template: "<div [class]=\"wrapperClass\" @flyInOut [@.disabled]=\"disableAnimation\" *ngIf=\"isActive\">\r\n  <ng-content></ng-content>\r\n</div>\r\n<div class=\"ng-busy-backdrop\" @flyInOut [@.disabled]=\"disableAnimation\" *ngIf=\"showBackdrop && isActive\">\r\n</div>\r\n",
                animations: [
                    trigger('flyInOut', [
                        transition('void => *', [
                            inactiveStyle,
                            animate(timing)
                        ]),
                        transition('* => void', [
                            animate(timing, inactiveStyle)
                        ])
                    ])
                ],
                styles: [""]
            }]
    }], function () { return [{ type: InstanceConfigHolderService, decorators: [{
                type: Inject,
                args: ['instanceConfigHolder']
            }] }, { type: ɵngcc0.EventEmitter, decorators: [{
                type: Inject,
                args: ['busyEmitter']
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class NgBusyDirective {
    constructor(configHolder, instanceConfigHolder, resolver, tracker, appRef, vcr, element, renderer, injector) {
        this.configHolder = configHolder;
        this.instanceConfigHolder = instanceConfigHolder;
        this.resolver = resolver;
        this.tracker = tracker;
        this.appRef = appRef;
        this.vcr = vcr;
        this.element = element;
        this.renderer = renderer;
        this.injector = injector;
        this.busyStart = new EventEmitter();
        this.busyStop = new EventEmitter();
        this.isLoading = false;
        this.busyEmitter = new EventEmitter();
        this.onStartSubscription = tracker.onStartBusy.subscribe(() => {
            setTimeout(() => {
                this.recreateBusyIfNecessary();
                this.isLoading = true;
                this.busyEmitter.emit(this.isLoading);
                this.busyStart.emit();
            }, 0);
        });
        this.onStopSubscription = tracker.onStopBusy.subscribe(() => {
            this.isLoading = false;
            this.busyEmitter.emit(this.isLoading);
            this.busyStop.emit();
        });
    }
    set options(op) {
        this._option = op;
    }
    get options() {
        return this._option;
    }
    ngDoCheck() {
        this.optionsNorm = this.normalizeOptions(this.options);
        this.instanceConfigHolder.config = this.optionsNorm;
        this.tracker.load({
            busyList: this.optionsNorm.busy,
            delay: this.optionsNorm.delay,
            minDuration: this.optionsNorm.minDuration
        });
    }
    ngOnDestroy() {
        this.destroyComponents();
        this.onStartSubscription.unsubscribe();
        this.onStopSubscription.unsubscribe();
    }
    recreateBusyIfNecessary() {
        if (!this.busyRef
            || this.template !== this.optionsNorm.template
            || this.templateNgStyle !== this.optionsNorm.templateNgStyle) {
            this.destroyComponents();
            this.template = this.optionsNorm.template;
            this.templateNgStyle = this.optionsNorm.templateNgStyle;
            this.createBusy();
            this.busyEmitter.emit(this.isLoading);
        }
    }
    normalizeOptions(options) {
        if (!options) {
            options = { busy: [] };
        }
        else if (Array.isArray(options)
            || isPromise(options)
            || options instanceof Subscription) {
            options = { busy: options };
        }
        options = Object.assign({}, this.configHolder.config, options);
        if (!Array.isArray(options.busy)) {
            options.busy = [options.busy];
        }
        return options;
    }
    destroyComponents() {
        if (this.busyRef) {
            this.busyRef.destroy();
        }
        if (this.componentViewRef) {
            this.appRef.detachView(this.componentViewRef);
        }
    }
    createBusy() {
        const factory = this.resolver.resolveComponentFactory(NgBusyComponent);
        const injector = Injector.create({
            providers: [
                {
                    provide: 'instanceConfigHolder',
                    useValue: this.instanceConfigHolder
                },
                {
                    provide: 'busyEmitter',
                    useValue: this.busyEmitter
                }
            ], parent: this.injector
        });
        this.template = this.optionsNorm.template;
        this.busyRef = this.vcr.createComponent(factory, 0, injector, this.generateNgContent(injector));
    }
    generateNgContent(injector) {
        if (typeof this.template === 'string') {
            const element = this.renderer.createText(this.template);
            return [[element]];
        }
        if (this.template instanceof TemplateRef) {
            const context = {};
            const viewRef = this.template.createEmbeddedView(context);
            return [viewRef.rootNodes];
        }
        const factory = this.resolver.resolveComponentFactory(this.template);
        const componentRef = factory.create(injector);
        componentRef.instance.templateNgStyle = this.options.templateNgStyle;
        this.componentViewRef = componentRef.hostView;
        this.appRef.attachView(this.componentViewRef);
        return [[componentRef.location.nativeElement]];
    }
}
NgBusyDirective.ɵfac = function NgBusyDirective_Factory(t) { return new (t || NgBusyDirective)(ɵngcc0.ɵɵdirectiveInject(BusyConfigHolderService), ɵngcc0.ɵɵdirectiveInject(InstanceConfigHolderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(BusyTrackerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
NgBusyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgBusyDirective, selectors: [["", "ngBusy", ""]], inputs: { options: ["ngBusy", "options"] }, outputs: { busyStart: "busyStart", busyStop: "busyStop" }, features: [ɵngcc0.ɵɵProvidersFeature([BusyTrackerService, InstanceConfigHolderService])] });
NgBusyDirective.ctorParameters = () => [
    { type: BusyConfigHolderService },
    { type: InstanceConfigHolderService },
    { type: ComponentFactoryResolver },
    { type: BusyTrackerService },
    { type: ApplicationRef },
    { type: ViewContainerRef },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Injector }
];
NgBusyDirective.propDecorators = {
    options: [{ type: Input, args: ['ngBusy',] }],
    busyStart: [{ type: Output }],
    busyStop: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgBusyDirective, [{
        type: Directive,
        args: [{
                selector: '[ngBusy]',
                providers: [BusyTrackerService, InstanceConfigHolderService]
            }]
    }], function () { return [{ type: BusyConfigHolderService }, { type: InstanceConfigHolderService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: BusyTrackerService }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Injector }]; }, { busyStart: [{
            type: Output
        }], busyStop: [{
            type: Output
        }], options: [{
            type: Input,
            args: ['ngBusy']
        }] }); })();

class NgBusyModule {
    static forRoot(config) {
        return {
            ngModule: NgBusyModule,
            providers: [
                { provide: BusyConfig, useValue: config }
            ]
        };
    }
}
NgBusyModule.ɵfac = function NgBusyModule_Factory(t) { return new (t || NgBusyModule)(); };
NgBusyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgBusyModule });
NgBusyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [BusyConfigHolderService, BusyTrackerService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgBusyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [DefaultBusyComponent, NgBusyDirective, NgBusyComponent],
                providers: [BusyConfigHolderService, BusyTrackerService],
                exports: [NgBusyDirective],
                entryComponents: [DefaultBusyComponent, NgBusyComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgBusyModule, { declarations: function () { return [DefaultBusyComponent, NgBusyDirective, NgBusyComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgBusyDirective]; } }); })();

/*
 * Public API Surface of ng-busy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BUSY_CONFIG_DEFAULTS, BusyConfig, DefaultBusyComponent, InstanceConfigHolderService, NgBusyComponent, NgBusyDirective, NgBusyModule, isPromise, BusyTrackerService as ɵa, BusyConfigHolderService as ɵb };

